import { classNames } from "helpers";
import React from "react";
import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";
import { ButtonLinkProps } from "./types";

const Button: React.FC<ButtonLinkProps> = ({
  to,
  children,
  disabled = false,
  endIcon,
  size,
  startIcon,
  variant,
  cssClassName,
}) => {

  const sizeClassName = () => {
    switch (size) {
      case "small":
          return "px-3 py-2 text-sm";
      case "medium":
          return "px-3 py-2";
      case "large":
         return "px-3.5 py-3.5";
      case "full":
        return "w-full px-3 py-3";
      default:
        return "w-max px-3 py-3";
    }
  };

  const variantClassName = () => {
    switch (variant) {
      case "text":
        return "text-blue-500";
      case "outlined":
        return "ring-1 ring-gray-300 hover:bg-blue-500 hover:ring-0 hover:text-white transition ease-in-out delay-150";
      case "primary":
        return "bg-blue-500 text-white hover:bg-blue-900 hover:text-white transition ease-in-out delay-150";
      case "secondary":
        return "bg-blue-100 text-blue-600 hover:bg-blue-600 hover:text-white transition ease-in-out delay-150";
      case "warning":
        return "bg-yellow-100 text-yellow-700 hover:bg-yellow-500 hover:text-white transition ease-in-out delay-150";
      case "remove":
        return "bg-red-100 text-red-600 hover:bg-red-500 hover:text-white transition ease-in-out delay-150";
      default:
        return "";
    }
  };


  const iconClassName = () => {
    switch (variant) {
      case "text":
        return "stroke-slate-600";
      case "outlined":
        return "stroke-[#181b31]";
      case "primary":
        return "stroke-[#fff]";
      case "secondary":
        return "stroke-blue-300";
      case "warning":
        return "stroke-yellow-600 group-hover:stroke-white";
      case "remove":
        return "strple-red-600";
      default:
        return "";
    }
  };

  const iconSize = () => {
    switch (size) {
      case "small":
        return "w-4 h-4";
      case "medium":
        return "w-5 h-5";
      case "large":
        return "w-5 h-5";
      case "full":
        return "w-5 h-5";
      default:
        return "w-5 h-5";
    }
  };

  return (
    <div className={size === "full" ? "w-full" : ""}>
      <Link
        to={to}
        onClick={(e) => e.stopPropagation()}
        className={classNames(
          "group",
          sizeClassName(),
          variantClassName(),
          cssClassName,
          "group flex items-center text-sm font-medium rounded-sm"
        )}
      >
        {startIcon && (
          <div className="flex items-center justify-center ">
            <ReactSVG
              src={startIcon}
              className={classNames(
                iconClassName(),
                iconSize(),
                "transition ease-in-out delay-150"
              )}
            />
          </div>
        )}
        {children && <span className="ml-2 mr-2 inline-block group-hover:text-inherit">{children}</span>}
        {endIcon && (
          <div className="flex items-center justify-center mr-2">
            <ReactSVG
              src={endIcon}
              className={classNames(
                iconClassName(),
                iconSize(),
                "transition ease-in-out delay-150"
              )}
            />
          </div>
        )}
      </Link>
    </div>
  );
};

export default React.memo(Button);